<div class="bin-settings-wrapper">
  <div class="header">Bin settings</div>
  <div class="label">
    <span>Bin size</span>
    <capra-icon
      icon="icon-info-outline"
      class="info-icon"
      capraTooltip
      [tooltipContent]="
        'Binned fields have a fixed bin size once created. Recalculate bin size by entering a new number or clicking the button below'
      "
      [tooltipInteractive]="false"
      tooltipPlacement="bottom"
    ></capra-icon>
  </div>
  <input
    type="number"
    step="0.01"
    class="form-control form-control-sm"
    [formControl]="binSizeControl"
    [value]="binSizeControl.value"
    (blur)="handleInputChange(0, $event.target.valueAsNumber, true)"
    (keydown)="handleInputChange($event.keyCode, $event.target.valueAsNumber, false)"
    placeholder="Enter bin size..."
  />
  <button
    (click)="useRecommendedBinSize()"
    [class.disabled]="showRecommendedBinSize ? disableUseRecommended || isLoading : 'true'"
    class="use-recommended-btn"
    capraTooltip
    [tooltipContent]="'You are already using the recommended bin size'"
    tooltipPlacement="bottom"
    [tooltipIsDisabled]="!showRecommendedBinSize || !disableUseRecommended || isLoading || !binSize"
  >
    Use recommended bin size
  </button>
  <div [ngClass]="{ hide: !showRecommendedBinSize }" class="recommended-bin-text">
    Recommended bin size:&nbsp;<span>{{ suggestedBinSize ? suggestedBinSize : 'Loading...' }}</span>
  </div>
</div>
